import { BrowserRouter } from 'react-router'

import './App.css'
import Routes from './routes'
import NoInternetSnackAlert from '@/components/NoInternetSnackAlert'
import PwaUpdatePrompt from '@/components/PwaUpdatePrompt'

const App = () => {
  return (
    <BrowserRouter>
      <Routes />
      <NoInternetSnackAlert />
      <PwaUpdatePrompt />
    </BrowserRouter>
  )
}

export default App
